import SeoLandingPage from '../SeoLandingPage';

const config = {
  seoKey: 'theatreSchool',
  eyebrow: 'Theatre School in Milton Keynes',
  h1: 'Theatre School',
  h1Accent: 'in Milton Keynes',
  intro:
    'Universal Performing Arts is a leading theatre school in Milton Keynes for ages 4–18. Weekly acting, singing and dance training together, taught by industry professionals — with regular productions and holiday bootcamps that take young performers from beginner to stage-ready.',
  heroImage:
    'https://customer-assets.emergentagent.com/job_class-manager-84/artifacts/4is8revz_040.JPG',
  bullets: [
    {
      title: 'One school for everything',
      body: 'Acting, singing and dance under one roof every week — no juggling three different schools.',
    },
    {
      title: 'Founded by professionals',
      body: 'Principal Sam Attwater (Hollyoaks, EastEnders, Dancing on Ice winner) and West End faculty.',
    },
    {
      title: 'A genuine season',
      body: 'Termly showcases, an annual full-scale production and West End-style holiday bootcamps.',
    },
    {
      title: 'Friendly for families',
      body: 'Free trial for every new student. 30% off for siblings. Flexible payment options.',
    },
  ],
  whatYouLearn: [
    { title: 'Acting', body: 'Improvisation, characterisation, script work, audition prep.' },
    { title: 'Singing', body: 'Technique, harmony, belt, mix and a working song book.' },
    { title: 'Dance', body: 'Jazz, contemporary, street and musical theatre choreography.' },
    { title: 'Performance', body: 'Termly showcases plus an annual production at a Milton Keynes venue.' },
    { title: 'Confidence', body: 'The single biggest thing parents tell us their kids gain at UPA.' },
    { title: 'Friendship', body: 'A studio community where shy kids become brave kids.' },
  ],
  ageGroups: [
    { ageRange: '3–5', label: 'Primatotterinas' },
    { ageRange: '4–6', label: 'Mini Stars' },
    { ageRange: '7–10', label: 'Juniors' },
    { ageRange: '11–18', label: 'Inters & Seniors' },
  ],
  relatedLinks: [
    { label: 'Musical Theatre Classes Milton Keynes', to: '/musical-theatre-classes-milton-keynes' },
    { label: 'Acting Classes Milton Keynes', to: '/acting-classes-milton-keynes' },
    { label: 'Singing Classes Milton Keynes', to: '/singing-classes-milton-keynes' },
    { label: 'Dance Classes Milton Keynes', to: '/dance-classes-milton-keynes' },
    { label: 'Holiday Bootcamps', to: '/bootcamps' },
    { label: 'About UPA', to: '/about' },
  ],
};

const TheatreSchoolMK = () => <SeoLandingPage config={config} />;
export default TheatreSchoolMK;
